import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";

import { cBalance } from "../../classes/balance";
import { cOrder } from "../../classes/order";
import { iAllPricesPrice, iBalance, iBalanceResponse, iClientOrderOption, iConfig, iConfigStrikes, iConfigToken, iEOPTContract, iHistoryRecording, iHistoryResponseRecordings, iOption, iOptionResponse, iOrder, iOrderResponse, iTokenContract } from "../../interfaces/interfaces";
import { isStaticTime } from "../../settings";
import { tDispatch, store } from "../store";
import { cOption } from '../../classes/option';
import { cHistoryRecording } from "../../classes/history";
import { cBigNumber } from "../../classes/BigNumber";

import { eAppActionTypes } from "./appTypes";
// import { eBasicActionTypes } from "../basic/basicTypes";
// import { eChromiaActionTypes } from "../chromia/chromiaTypes";
// import { eModalsActionTypes } from "../modals/modalsTypes";
// import { eProActionTypes } from "../pro/proTypes";
// import { eUIActionTypes } from "../UI/UITypes";
import { cClientOrderOption } from "../../classes/chromiaClientOrderOption";

export const clearAppState = () => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.CLEAR_STATE
		})
	}
}

export const setUserAddress = (address: string | null) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_USER_ADDRESS,
			payload: address
		})
	}
}

export const setApi = (api: string) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_API,
			payload: api
		})
	}
}

export const setConfig = (config: iConfig) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_CONFIG,
			payload: config
		})
	}
}

export const setEOPTContract = (contract: iEOPTContract) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_EOPT_CONTRACT,
			payload: contract
		})
	}
}

export const setToken = (configToken: iConfigToken, contract: iTokenContract, type: 'funding' | 'underlying') => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_TOKEN,
			payload: {
				currency: configToken.name,
				address: configToken.address,
				decimals: configToken.decimals,
				showDecimals: configToken.showDecimals,
				type,
				contract
			}
		})
	}
}

export const setSystemTimestamp = (timestamp: number) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_SYSTEM_TIMESTAMP,
			payload: timestamp
		})
	}
}

/* export const setWeb3Provider = (provider: iWeb3Provider) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_WEB3_PROVIDER,
			payload: provider
		})
	}
} */

/* export function disconnect_app() {   // clears all states
	const { web3_provider } = store.getState().app;

	switch (blockchain) {
		case 'binance':
			localStorage.removeItem('WEB3_CONNECT_CACHED_PROVIDER');
			if (localStorage.getItem('walletconnect') && web3_provider && web3_provider.disconnect){      // causes bugs without this check
				web3_provider.disconnect();
			}
			break;

		case 'chromia':
			// localStorage.removeItem('CHROMIA_CONNECT_CACHED_DETAILS');
			break;

		default:
			break;
	}

	return (dispatch: tDispatch) => {
		setTimeout(() => {  // otherwise causes problems with reconnect
			dispatch({
				type: eProActionTypes.CLEAR_STATE
			});
			dispatch({
				type: eChromiaActionTypes.CLEAR_STATE
			});
			dispatch({
				type: eBasicActionTypes.SET_CURRENT_STEP,
				payload: 1
			});
			dispatch({
				type: AM_action_types.CLOSE_APPROVE_MODAL
			});
			dispatch({
				type: obm_action_types.CLOSE_MODAL
			});
			dispatch({
				type: eAppActionTypes.CLEAR_STATE,
			});
			dispatch({
				type: eUIActionTypes.CLEAR_STATE,
			})
		});
	}
} */

/* export const disconnectApp = () => {
	return (dispatch: tDispatch) => {
		// setTimeout(() => {  // otherwise causes problems with reconnect
			dispatch({
				type: eAppActionTypes.CLEAR_STATE
			});
			dispatch({
				type: eBasicActionTypes.SET_CURRENT_STEP,
				payload: 1
			});
			dispatch({
				type: eChromiaActionTypes.CLEAR_STATE
			});
			dispatch({
				type: eModalsActionTypes.CLEAR_STATE
			});
			dispatch({
				type: eProActionTypes.CLEAR_STATE
			});
			dispatch({
				type: eUIActionTypes.CLEAR_STATE
			});
		// });
	}
} */

export const setIsPro = (isPro: boolean) => {
	localStorage.setItem('eopt_mode', isPro? 'pro' : 'basic');
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_IS_PRO,
			payload: isPro
		})
	}
}

export const setTokenPrice = (currency: string, price: cBigNumber) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_TOKEN_PRICE,
			payload: {currency, price}
		})
	}
}

export const setCurrentOptions = (options: iOption[]) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_CURRENT_OPTIONS,
			payload: options
		})
	}
}

export const setClientBalances = (balances: iBalance[]) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_CLIENT_BALANCES,
			payload: balances
		})
	}
}

export const getPricesAndTimeThunk = (api?: string): ThunkAction<Promise<void>, any, unknown, AnyAction> => {
	return async (dispatch: tDispatch) => {
		const resApi = api || store.getState().app.api;

		if (!resApi) throw new Error(`Error code: 4_0`);

		let response = await fetch (resApi + '/prices/');
		if (!response.ok) throw new Error('Error code: 4_3');
		let allPrices: iAllPricesPrice[] = await response.json();
		for (let price of allPrices){
			price.price && dispatch({
				type: eAppActionTypes.SET_TOKEN_PRICE,
				payload: {currency: price.name ,price: new cBigNumber(price.price)}
			})
		}

		let resTime = 0;
		if (isStaticTime){	// for static time tn
			const contract = store.getState().app.EOPTContract;
			if (!contract) throw new Error(`Error code: 4_0`);
			// contract_ts = + await contract.methods.now_time().call();
			resTime = + await contract.methods.now_time().call();
		} else {
			resTime = allPrices[0].timestamp;
		}
		/* switch (blockchain) {
			case 'binance':

				// let contract_ts = 0;
				if (isStaticTime){	// for static time tn
					const contract = store.getState().app.EOPTContract;
					if (!contract) throw new Error(`Error code: 4_0`);
					// contract_ts = + await contract.methods.now_time().call();
					resTime = + await contract.methods.now_time().call();
				} else {
					resTime = allPrices[0].timestamp;
				}
				// res_time = isStaticTime? contract_ts : all_prices[0].timestamp
				break;

			case 'chromia':
				resTime = await getChrTime();
				break;

			default:
				throw new Error();
		} */

		dispatch({
			type: eAppActionTypes.SET_SYSTEM_TIMESTAMP,
			// payload: is_static_time? contract_ts : all_prices[0].timestamp
			payload: resTime
			// payload: 1648120746
		})
	}
}

export const getOptionsThunk = (): ThunkAction<Promise<void>, any, unknown, AnyAction> => {
	return async (dispatch: tDispatch) => {
		const { api, systemTimestamp, tokens } = store.getState().app;

		if (!api || systemTimestamp === null) throw new Error(
			'Error code: 4_1' +
			(api? '' : '\napi: -') +
			(systemTimestamp? '' : '\ntime: -')
		);

		let response = await fetch (api + `/options/all/orders?maturity=${systemTimestamp}`);
		if (!response.ok) throw new Error('Error code: 4_4');
		const fTokenAddresses = tokens.filter(token => token.type === 'funding').map(token => token.address.toLowerCase());
		const responseOptions: iOptionResponse[] = await response.json();
		// responseOptions.filter(option => fTokenAddresses.includes(option.f_token));
		/* let options: iOption[] = [];
		for (let response_option of responseOptions){
			options.push( new cOption(response_option) );
		} */

		const options = responseOptions.filter(option => fTokenAddresses.includes(option.f_token.toLowerCase())).map(option => new cOption(option));
		dispatch({
			type: eAppActionTypes.SET_CURRENT_OPTIONS,
			payload: options
		})
	}
}

export const getClientBalancesThunk = (): ThunkAction<Promise<void>, any, unknown, AnyAction> => {
	return async (dispatch: tDispatch) => {
		const { api, userAddress } = store.getState().app;

		if (!api || !userAddress) throw new Error(
			'Error code: 4_2' +
			(api? '' : '\napi: -') +
			(userAddress? '' : '\naddr: -')
		);

		let json = await fetch(api + `/clients/${userAddress}/balance`);
		if (!json.ok) throw new Error('Error code: 4_5');
		let response: iBalanceResponse[] = await json.json();
		let balances: iBalance[] = [];
		for (let balance_part of response) {
			balances.push(new cBalance(balance_part))
		};

		dispatch({
			type: eAppActionTypes.SET_CLIENT_BALANCES,
			payload: balances
		})
	}
}

export const getClientOrdersThunk = (): ThunkAction<Promise<void>, any, unknown, AnyAction> => {
	return async (dispatch: tDispatch) => {
		const { api, userAddress } = store.getState().app;

		if (!api || !userAddress) throw new Error(
			'Error code: 4_9' +
			(api? '' : '\napi: -') +
			(userAddress? '' : '\naddr: -')
		);

		let json = await fetch(api + `/clients/${userAddress}/orders`);
		if (!json.ok) throw new Error('Error code: 4_6');
		let response: iOrderResponse[] = await json.json();
		console.log('getClientOrdersThunk', response)
		
		// let orders: iOrder[] = [];
		// let orders: iClientOrderOption[] = [];

		const { systemTimestamp } = store.getState().app;
		const orders = response.map(async order => {
			return new cClientOrderOption(null, null, systemTimestamp!, order);
		});
		const res = await Promise.all(orders);
		// for (let orderOption of res) {
		// 	try {
		// 		// orders.push(new cOrder(order_response));
		// 		orders.push(orderOption);
		// 	} catch (err) {
		// 		console.warn(err);
		// 	}
		// };

		dispatch({
			type: eAppActionTypes.SET_CLIENT_ORDERS,
			payload: res
		})
	}
}

export const setDarkMode = (state: boolean) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_DARK_MODE,
			payload: state
		})
	}
}

export const getClientHistoryThunk = (): ThunkAction<Promise<void>, any, unknown, AnyAction> => {
	return async (dispatch: tDispatch) => {
		const { api, userAddress } = store.getState().app;

		if (!api || !userAddress) throw new Error(
			'Error code: 4_10' +
			(api? '' : '\napi: -') +
			(userAddress? '' : '\naddr: -')
		);

		dispatch({
			type: eAppActionTypes.SET_IS_HISTORY_UPDATING,
			payload: true,
		})

		let response_1 = await fetch(api + `/options/`);  // all time
		if (!response_1.ok) throw new Error('Error code: 4_7');
		const responseOptions: iOptionResponse[] = await response_1.json();
		/* let options: iOption[] = [];
		for (let response_option of response_options){
			options.push( new cOption(response_option) );
		} */
		const options = responseOptions.map(option => new cOption(option));
		dispatch({
			type: eAppActionTypes.SET_ALL_OPTIONS,
			payload: options
		})


		let response_2 = await fetch(api + `/clients/${userAddress}/history`);
		if (!response_2.ok) throw new Error('Error code: 4_8');
		let history_response: iHistoryResponseRecordings[] = await response_2.json();

		let history: iHistoryRecording[] = [];
		for (let recording_response of history_response) {
			history.push(new cHistoryRecording(recording_response));
		};

		dispatch({
			type: eAppActionTypes.SET_HISTORY_RECORDINGS,
			payload: history
		})
	}
}

export const setOptionsPeriodOptions = (period: 'all' | 'daily' | 'weekly' | 'non-standart') => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_OPTIONS_PERIOD,
			payload: period
		})
	}
}

export const updateConfigStrikes = (strikes: iConfigStrikes) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.UPDATE_STRIKES,
			payload: strikes
		})
	}
}

export const setKasAccessToken = (token: string) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_KAS_ACCESS_TOKEN,
			payload: token
		})
	}
}